import type MetaInterface from '@/interfaces/MetaInterface';
  
  // This file is auto-generated by the build system.
  const meta: MetaInterface = {
    version: '1.0.2',
    date: '2026-08-05T15:17:53.252Z',
  };
  export default meta;
  